import { SchoolData } from "@nimble/candidate-api/types";
import { ArrowLeft } from "lucide-react";
import { ReactNode } from "react";

import { PrincipalCardPreset } from "@/app/(discover)/candidate/invites/components/principal-card";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

export type RespondDrawerProps = {
  children: ReactNode;
  onClose: () => void;
  schoolData: SchoolData;
};

export default function RespondDrawer({
  children,
  onClose,
  schoolData,
}: RespondDrawerProps) {
  return (
    <Sheet open onOpenChange={onClose}>
      <SheetContent side="right" className="w-full">
        <SheetTitle className="sr-only">Respond to Principal</SheetTitle>
        <div className="flex items-center justify-between gap-4 px-4 py-3 border-b border-border bg-card sticky top-0 z-10">
          <div className="flex items-center gap-3">
            <Button variant="outline" onClick={onClose}>
              <ArrowLeft />
            </Button>
            <PrincipalCardPreset schoolData={schoolData} />
          </div>
        </div>
        <div className="overflow-auto p-4 pt-0">{children}</div>
      </SheetContent>
    </Sheet>
  );
}
